<mat-toolbar class="mat-primary">
  <span fxFlex>Durchführungstermin festlegen</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <form [formGroup]="inputData.inputForm" *ngIf="inputData.inputForm">
    <div class="wrapper">
      <p>
        <strong>Wunschtermin des Kunden:</strong>
        {{ inputData.commissioningOrderDto.supplyAppointmentWishDate | date : 'shortDate' }}
        ({{ inputData.commissioningOrderDto.supplyAppointmentWishPartday | supplyAppointmentPartDay }})
      </p>
      <div class="col" fxFlex="100">
        <div fxLayout="row" fxFlexAlign="stretch">
          <mat-form-field appearance="outline" fxFlex="35" name="date" style="margin-right: 1rem">
            <mat-label>Datum:</mat-label>
            <input
              matInput
              formControlName="date"
              [matDatepicker]="supplyAppointment"
              (dateChange)="changeData()"
              placeholder="Durchführungstermin:" />
            <mat-datepicker-toggle matSuffix [for]="supplyAppointment"></mat-datepicker-toggle>
            <mat-datepicker #supplyAppointment></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="17" name="time">
            <mat-label>Uhr:</mat-label>
            <input matInput type="time" (change)="changeData()" formControlName="time" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <mat-error *ngIf="isError">Datum und Uhrzeit sind erforderlich</mat-error>
  </form>

  <p>
    Hinweis: Wenn Sie den Durchführungstermin ändern, können Sie eine Benachrichtigung über das Portal
    versenden.
  </p>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>

    <button
      mat-raised-button
      color="primary"
      id="modal-confirm-button"
      [disabled]="!changeSupplyAppointment"
      (click)="confirm()">
      Speichern
      <span *ngIf="inputData.commissioningOrderDto.state == commissioningStatusEnum.Approved">
        und E-Mail an Kunde senden
      </span>
    </button>
  </div>
</mat-dialog-content>
